<div class="card mb-5 horizontal-bar-chart-segment" [ngStyle]="rootStyleVars">
  <div class="card-header" style="border-bottom: none">
    <div class="card-title d-flex flex-column">
      <h4>{{ data?.title }}</h4>
    </div>
  </div>

  <div class="card-body">
    <div class="legend-row" *ngIf="legendItems.length">
      <div *ngFor="let legend of legendItems" class="legend-item">
        <span class="legend-swatch" [style.background]="legend.color"></span>
        <span class="legend-label">{{ legend.label }}</span>
      </div>
    </div>

    <div *ngIf="isLoading" class="state-text">Loading data...</div>
    <div *ngIf="!isLoading && hasError" class="state-text error-text">{{ errorMessage }}</div>

    <div *ngIf="!isLoading && !hasError && parentGroups.length" class="segment-list">
      <section *ngFor="let group of parentGroups" class="segment-group">
        <div class="segment-group-header">
          <button
            type="button"
            class="segment-group-title"
            [class.is-clickable]="data?.enableLabelClick"
            (click)="handleCategoryClick(group.filterValue, $event)"
          >
            {{ group.label }}
          </button>
          <span class="segment-group-total">Total: {{ formatValue(group.total) }}</span>
        </div>

        <div class="segment-group-layout" [class.is-compact]="compactMode">
          <div
            class="segment-item parent-item"
            [class.is-selected]="isSelected(group.filterValue)"
            [class.is-muted]="isMuted(group.filterValue)"
          >
            <div class="item-header">
              <button
                type="button"
                class="item-title"
                [class.is-clickable]="data?.enableLabelClick"
                (click)="handleCategoryClick(group.filterValue, $event)"
              >
                {{ group.label }}
              </button>
              <span class="segment-total">{{ formatValue(group.total) }}</span>
            </div>

            <div
              class="bar-shell parent-bar"
              [class.is-clickable]="data?.enableLabelClick"
              (click)="handleCategoryClick(group.filterValue, $event)"
            >
              <div
                *ngFor="let segment of group.segments"
                class="bar-segment"
                [style.width.%]="segment.percent"
                [style.background]="segment.color"
                [attr.title]="segment.label + ': ' + formatValue(segment.value)"
              >
                <span
                  *ngIf="shouldShowPercent(segment.percent)"
                  class="segment-label"
                  [class.dark]="useDarkText(segment.color)"
                >
                  {{ formatPercent(segment.percent) }}
                </span>
              </div>
            </div>

            <div class="segment-meta compact">
              <span *ngFor="let segment of group.segments">
                {{ segment.label }}: {{ formatValue(segment.value) }}
              </span>
            </div>
          </div>

          <div
            *ngIf="group.children.length"
            class="child-strip-viewport"
            [class.is-scrollable]="isScrollableRow(group)"
            [class.is-compact]="compactMode"
          >
            <div
              class="child-strip"
              [class.is-fill-row]="shouldFillChildRow(group)"
              [class.is-scrollable]="isScrollableRow(group)"
              [class.is-compact]="compactMode"
            >
              <div
                *ngFor="let child of group.children"
                class="segment-item child-item"
                [class.is-selected]="isSelected(child.filterValue)"
                [class.is-muted]="isMuted(child.filterValue)"
              >
                <div class="item-header">
                  <button
                    type="button"
                    class="item-title"
                    [class.is-clickable]="data?.enableLabelClick"
                    (click)="handleCategoryClick(child.filterValue, $event)"
                  >
                    {{ child.label }}
                  </button>
                  <span class="segment-total">{{ formatValue(child.total) }}</span>
                </div>

                <div
                  class="bar-shell child-bar"
                  [class.is-clickable]="data?.enableLabelClick"
                  (click)="handleCategoryClick(child.filterValue, $event)"
                >
                  <div
                    *ngFor="let segment of child.segments"
                    class="bar-segment"
                    [style.width.%]="segment.percent"
                    [style.background]="segment.color"
                    [attr.title]="segment.label + ': ' + formatValue(segment.value)"
                  >
                    <span
                      *ngIf="shouldShowPercent(segment.percent)"
                      class="segment-label"
                      [class.dark]="useDarkText(segment.color)"
                    >
                      {{ formatPercent(segment.percent) }}
                    </span>
                  </div>
                </div>

                <div class="segment-meta compact">
                  <span *ngFor="let segment of child.segments">
                    {{ segment.label }}: {{ formatValue(segment.value) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
